/**
 * Created by qlong on 9/12/2016.
 */
const initialState = {
    selected_filename: "",
    chartData: {},
}

export default function reducer(state=initialState,action) {
    switch (action.type) {
        case "ON_FILE_LOAD":
            return {...state, selected_filename: action.payload.selected_filename, chartData: action.payload.chartData}
        case "ON_FILE_CHANGE":
                return initialState
    }
    return state
}


/** WEBPACK FOOTER **
 ** ./src/reducers/fileDataReducer.js
 **/